import React from 'react';
import ReferenceInput, { getChildrenProps } from '../ReferenceInput';
import { AutocompleteInput } from 'react-admin';
import { ENUMS } from '../Enum/enums';

const ScreenerAccountInput = (props) => {
  return (
    <ReferenceInput {...props} gql={['id', 'name', 'first_name', 'last_name']}>
      <AutocompleteInput
        optionText={(record) => record?.name || `${record?.first_name} ${record?.last_name}`}
        {...getChildrenProps(props)}
        onKeyDown={(e) => e.stopPropagation()}
        data-testid="screener-account-input"
      />
    </ReferenceInput>
  );
};

ScreenerAccountInput.defaultProps = {
  emptyText: 'All',
  reference: 'Account',
  filter: {
    permission_group_roles: [ENUMS.PermissionGroup.role.support_agent],
    status: 'active',
  },
  sort: { field: 'first_name', order: 'ASC' },
  perPage: 100,
};

export default ScreenerAccountInput;
